import { WORK_COPY } from "./constants.ts";
import "./workThumb.css";

/**
 * The photograph at the top of a work card, wherever one is rendered.
 *
 * Shared by the dashboard strip and the collection grid on purpose: both show
 * the same photograph — the first image on the record, see `fetchWorkImages` —
 * and a card that framed it differently on one screen would read as a different
 * work.
 *
 * A missing photograph keeps the frame rather than closing it up, so a work
 * without one does not look like an image that failed to load.
 */
export function WorkThumb({ imageUrl, title }: { imageUrl: string | null; title: string }) {
  if (imageUrl === null) {
    return <span className="work-thumb work-thumb--none">{WORK_COPY.noImage}</span>;
  }

  return (
    <img
      className="work-thumb"
      src={imageUrl}
      alt={`${WORK_COPY.imageOf} ${title}`}
      loading="lazy"
    />
  );
}
